export const FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_REQUEST = 'FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_REQUEST'
export const FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_SUCCESS = 'FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_SUCCESS'
export const FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_FALUIRE = 'FETCH_LIST_ALL_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_FALUIRE'
